<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("CEE") || "Certificats d'Économie d'Énergie" }}</h1>
      <b-button
        size="sm"
        variant="success"
        class="button-succes-style ml-2 float-right mb-2"
        @click="goToCreate"
        ><font-awesome-icon icon="plus-circle" /> {{ $t("NEW") }}
      </b-button>
    </div>
    <div class="content">
      <div class="content-header">
        <searchBar
          :searchText="$t('SEARCH')"
          :searchFunc="searchCEE"
          :filtre="{
            entreprise: isSuperAdmin ? currententreprise : null,
            delegataire: currentdelegataire,
          }"
          :showFiltre="isSuperAdmin"
          @returnValue="updateSearch($event)"
        ></searchBar>
        <!--------------------------------------- entrepriseModal --------------------------------------->
        <b-modal id="entrepriseModal" ref="entrepriseModal">
          <template #modal-header="{ close }">
            <h5>{{ $t("COMPANY_ID") }}</h5>
            <b-button size="sm" @click="close()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.028"
                height="17.028"
                viewBox="0 0 17.028 17.028"
              >
                <path
                  id="Icon_material-close"
                  data-name="Icon material-close"
                  d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                  transform="translate(-7.5 -7.5)"
                  fill="#393939"
                />
              </svg>
            </b-button>
          </template>

          <form @submit.prevent="hideModal('entrepriseModal')">
            <div class="center">
              <b-form-group :label="$t('COMPANY_ID')" v-if="this.isSuperAdmin">
                <searchInput
                  :list="getAllentreprises"
                  :loader="getentrepriseLoading"
                  label="lib"
                  :searchFunc="all_entreprises"
                  @searchfilter="selectentreprise($event)"
                ></searchInput>
              </b-form-group>

              <b-form-group :label="$t('DELEGATAIRE')">
                <searchInput
                  :list="getAllEntitesExternes"
                  :loader="getLoadingEntiteExterne"
                  label="nom"
                  :searchFunc="loadDelegataires"
                  @searchfilter="selectdelegataire($event)"
                ></searchInput>
              </b-form-group>
            </div>
          </form>
          <template #modal-footer>
            <div class="actionModel">
              <b-button variant="success" @click="setup(true)">
                <div class="block-spinner">
                  {{ $t("Appliquer") }}
                </div>
              </b-button>
            </div>
          </template>
        </b-modal>
        <!--------------------------------------- end entrepriseModal --------------------------------------->
      </div>
      <div class="filtre">
        <p class="table-count">
          {{ getTotalRowCEE }} {{ $t("CEE") || "Certificats" }}
        </p>
        <div class="productTrie" v-if="isSuperAdmin && currententreprise && currententreprise.lib">
          {{ currententreprise.lib }}
          <font-awesome-icon
            icon="times-circle"
            class="icons"
            @click="clearEntrepriseFilter()"
          />
        </div>
        <div class="productTrie" v-if="currentdelegataire && currentdelegataire.nom">
          {{ currentdelegataire.nom }}
          <font-awesome-icon
            icon="times-circle"
            class="icons"
            @click="clearDelegataireFilter()"
          />
        </div>
      </div>
      <div class="table-rapport-style w-100">
        <table>
          <thead>
            <tr>
              <th style="border-radius: 5px 0px 0px 0px">
                {{ $t("CLIENT") }}
              </th>
              <th v-if="isSuperAdmin">
                {{ $t("ENTREPRISES") }}
              </th>
              <th>
                {{ $t("Type de travaux") }}
              </th>
              <th>
                {{ $t("DELEGATAIRE") }}
              </th>
              <th>
                {{ $t("Type de prime") }}
              </th>
              <th>
                {{ $t("Montant") }}
              </th>
              <th>
                {{ $t("DOWNLOAD") }}
              </th>
              <th style="border-radius: 0px 5px 0px 0px" class="action_head"></th>
            </tr>
          </thead>

          <tbody>
            <tr
              role="row"
              class="ligneNormale"
              v-for="(data, i) in filteredCEE"
              :key="i"
            >
              <td aria-colindex="1" role="cell">
                {{ getClientName(data) }}
              </td>
              <td aria-colindex="2" role="cell" v-if="isSuperAdmin">
                {{ getEntrepriseName(data) }}
              </td>
              <td aria-colindex="3" role="cell">
                {{ getTypeTravaux(data) }}
              </td>
              <td aria-colindex="4" role="cell">
                {{ getDelegataireName(data) }}
              </td>
              <td aria-colindex="5" role="cell">
                {{ getTypePrime(data) }}
              </td>
              <td aria-colindex="6" role="cell">
                {{ formatAmount(data) }}
              </td>
              <td aria-colindex="7" role="cell">
                <div class="grey" @click="handleDownload(data)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 20.944 20.944"
                  >
                    <g
                      id="Icon_feather-download"
                      data-name="Icon feather-download"
                      transform="translate(-3.5 -3.5)"
                    >
                      <path
                        id="Tracé_78100"
                        data-name="Tracé 78100"
                        d="M23.444,22.5v4.21a2.1,2.1,0,0,1-2.1,2.1H6.6a2.1,2.1,0,0,1-2.1-2.1V22.5"
                        transform="translate(0 -5.37)"
                        fill="none"
                        stroke="#28367a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        id="Tracé_78101"
                        data-name="Tracé 78101"
                        d="M10.5,15l5.262,5.262L21.025,15"
                        transform="translate(-1.79 -3.133)"
                        fill="none"
                        stroke="#28367a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                      <path
                        id="Tracé_78102"
                        data-name="Tracé 78102"
                        d="M18,17.13V4.5"
                        transform="translate(-4.028)"
                        fill="none"
                        stroke="#28367a"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      />
                    </g>
                  </svg>
                </div>
              </td>
              <td aria-colindex="8" role="cell" class="action_col">
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="danger"
                  @click.prevent.stop="handleDelete(data)"
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="success"
                  @click.prevent.stop="handleUpdate(data)"
                >
                  <font-awesome-icon icon="pencil-alt" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <deleteModalVue
        :loader="getCEELoading"
        :elemToDelete="delete_CEE"
        :elemDelete="deleteCEE"
        @updateList="setup(false)"
      ></deleteModalVue>

      <b-pagination
        v-model="page"
        :total-rows="getTotalRowCEE"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
    </div>

    <div class="text-center center-spin">
      <b-spinner
        v-if="getCEELoading"
        variant="primary"
        label="Spinning"
        class="big-spin"
      ></b-spinner>
    </div>
    <CommentMarche to="/how-it-work/cee"></CommentMarche>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import deleteModalVue from "../components/ui/deleteModal.vue";
import searchBar from "../components/ui/searchBar.vue";
import searchInput from "../components/ui/searchInput.vue";
import CommentMarche from "../components/commentMarche.vue";

export default {
  components: {
    searchBar,
    searchInput,
    deleteModalVue,
    CommentMarche,
  },
  data() {
    return {
      search: "",
      delete_CEE: null,
      page: 1,
      perPage: 10,
      currententreprise: null,
      filtre_entreprise: null,
      currentdelegataire: null,
      filtre_delegataire: null,
      downloadUrl: "https://beta-api.batigo.fr/storage/",
    };
  },
  methods: {
    ...mapActions([
      "allCEE",
      "deleteCEE",
      "all_entreprises",
      "allEntitesExternes",
      "downloadPdfCEE",
    ]),

    updateSearch(s) {
      this.page = 1;
      this.search = s;
      this.setup(false);
    },

    async searchCEE() {
      await this.setup(false);
    },

    clearEntrepriseFilter() {
      this.currententreprise = null;
      this.filtre_entreprise = null;
      this.setup(true);
    },

    selectentreprise(query) {
      if (query) {
        this.filtre_entreprise = query;
      } else {
        this.filtre_entreprise = {
          lib: null,
        };
      }
    },

    clearDelegataireFilter() {
      this.currentdelegataire = null;
      this.filtre_delegataire = null;
      this.setup(true);
    },

    selectdelegataire(query) {
      if (query) {
        this.filtre_delegataire = query;
      } else {
        this.filtre_delegataire = {
          nom: null,
        };
      }
    },

    async loadDelegataires(payload) {
      // Charger les entités externes de type délégataire
      await this.allEntitesExternes({
        page: payload?.page || 1,
        per_page: payload?.per_page || 10000,
        type: 'delegataire',
        nom: payload?.search || null,
      });
    },

    hideModal(ref) {
      this.$refs[ref].hide();
    },

    openModal(ref) {
      this.$refs[ref].show();
    },

    formatDate(date) {
      if (!date) return "-";
      return moment(date).format("DD-MM-YYYY");
    },

    formatAmount(data) {
      if (!data) return "-";
      if (data.montant_prime) {
        return `${data.montant_prime} €`;
      }
      if (data.montant_bon_achat) {
        return `${data.montant_bon_achat} €`;
      }
      if (data.montant_pret) {
        return `${data.montant_pret} €`;
      }
      if (data.valeur_audit) {
        return `${data.valeur_audit} €`;
      }
      if (data.valeur_produit_service) {
        return `${data.valeur_produit_service} €`;
      }
      return "-";
    },

    getTypePrime(data) {
      if (!data || !data.type_prime) {
        return "-";
      }
      
      // Handle array of types
      const types = Array.isArray(data.type_prime) ? data.type_prime : [data.type_prime];
      const typeLabels = {
        prime: "Prime",
        bon_achat: "Bon d'achat",
        pret_bonifie: "Prêt bonifié",
        audit: "Audit/Conseil",
        produit_service: "Produit/Service",
      };
      
      const labels = types
        .map((type) => typeLabels[type] || type)
        .filter(Boolean);
      
      return labels.length > 0 ? labels.join(", ") : "-";
    },

    getClientName(data) {
      if (!data) return "-";
      if (data.client) {
        if (data.client.type === "type.professionnel" && data.client.company) {
          return data.client.company;
        }
        const nom = data.client.nom || "";
        const prenom = data.client.prenom || "";
        return `${prenom} ${nom}`.trim() || "-";
      }
      return "-";
    },

    getEntrepriseName(data) {
      if (!data) return "-";
      if (data.entreprise && data.entreprise.lib) {
        return data.entreprise.lib;
      }
      return "-";
    },

    getTypeTravaux(data) {
      if (!data) return "-";
      if (data.type_travaux) {
        return data.type_travaux;
      }
      return "-";
    },

    getDelegataireName(data) {
      if (!data) return "-";
      if (data.delegataire && data.delegataire.nom) {
        return data.delegataire.nom;
      }
      return "-";
    },

    handleDelete(cee) {
      this.delete_CEE = { ...cee };
      this.$root.$emit("bv::show::modal", "ModelDelete");
    },

    goToCreate() {
      this.$router.push("/CEE/create");
    },

    handleUpdate(cee) {
      this.$router.push(`/CEE/edit/${cee.id}`);
    },

    pagination(paginate) {
      this.page = paginate;
      this.setup(false);
    },

    async handleDownload(cee) {
      try {
        const response = await this.downloadPdfCEE(cee.id);
        if (response && response.data) {
          const pdfData = response.data;
          // Ouvrir le PDF dans un nouvel onglet
          if (pdfData.download_url) {
            window.open(pdfData.download_url, "_blank");
          } else if (pdfData.pdf_path) {
            // Si l'API retourne seulement le chemin, construire l'URL complète
            const downloadUrl = this.downloadUrl || "https://beta-api.batigo.fr/storage/";
            window.open(downloadUrl + pdfData.pdf_path.replace("storage/app/public/", ""), "_blank");
          }
        }
      } catch (error) {
        console.error("Error downloading CEE PDF:", error);
        alert(error?.response?.data?.message || error?.message || "Une erreur est survenue lors du téléchargement.");
      }
    },

    setup(refresh = false) {
      if (refresh) this.page = 1;

      this.currententreprise = this.filtre_entreprise;
      this.currentdelegataire = this.filtre_delegataire;
      if (this.$refs["entrepriseModal"]) {
        this.$refs["entrepriseModal"].hide();
      }

      const params = {
        page: this.page,
        per_page: this.perPage,
        search: this.search || null,
      };

      if (this.currententreprise) {
        if (typeof this.currententreprise === 'object' && this.currententreprise.id) {
          params.entreprise_id = this.currententreprise.id;
        } else if (typeof this.currententreprise === 'number' || typeof this.currententreprise === 'string') {
          params.entreprise_id = this.currententreprise;
        } else {
          params.entreprise = this.currententreprise;
        }
      } else if (!this.isSuperAdmin && this.getOnlineUser) {
        if (this.getOnlineUser.entreprise) {
          if (typeof this.getOnlineUser.entreprise === 'object' && this.getOnlineUser.entreprise.id) {
            params.entreprise_id = this.getOnlineUser.entreprise.id;
          } else if (typeof this.getOnlineUser.entreprise === 'number' || typeof this.getOnlineUser.entreprise === 'string') {
            params.entreprise_id = this.getOnlineUser.entreprise;
          } else {
            params.entreprise = this.getOnlineUser.entreprise;
          }
        }
      }

      if (this.currentdelegataire) {
        if (typeof this.currentdelegataire === 'object' && this.currentdelegataire.id) {
          params.delegataire_id = this.currentdelegataire.id;
        } else if (typeof this.currentdelegataire === 'number' || typeof this.currentdelegataire === 'string') {
          params.delegataire_id = this.currentdelegataire;
        }
      }

      this.allCEE(params);
    },
  },

  async mounted() {
    this.setup(true);
    if (this.isSuperAdmin) {
      this.all_entreprises({
        page: 1,
        per_page: 1000,
      });
    }
    // Charger les délégataires pour le filtre
    this.loadDelegataires({
      page: 1,
      per_page: 10000,
    });
  },

  computed: {
    ...mapGetters([
      "getAllCEE",
      "getCEELoading",
      "getTotalRowCEE",
      "getTabs",
      "getOnlineUser",
      "getAllentreprises",
      "getentrepriseLoading",
      "getAllEntitesExternes",
      "getLoadingEntiteExterne",
    ]),
    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    filteredCEE() {
      if (!this.getAllCEE || !Array.isArray(this.getAllCEE)) {
        return [];
      }
      return this.getAllCEE.filter(item => item !== null && item !== undefined);
    },
  },
};
</script>

<style lang="scss" scoped>
.filtre {
  display: flex;
  align-items: center;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}

.grey {
  background-color: #f5f6f8;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  margin: 0 auto;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #e9ecef;
  }
}

.table-rapport-style {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
    
    &:hover {
      background: #555;
    }
  }
  
  table {
    min-width: 100%;
    white-space: nowrap;
    
    th, td {
      white-space: nowrap;
    }
  }
}
</style>

